<template>
  <div 
    class="toast fade show p-2 toast-notification" 
    :class="[getColor(type), positionClass]"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="toast-header bg-transparent border-0">
      <i class="material-icons me-2 text-white">{{ getIconName(type) }}</i>
      <span class="me-auto font-weight-bold text-white">{{ title }}</span>
      <i
        class="fas fa-times text-md ms-3 cursor-pointer text-white"
        @click="close"
      />
    </div>
    <hr class="horizontal light m-0" />
    <div class="toast-body text-white">{{ message }}</div>
  </div>
</template>

<script>
export default {
  name: "ToastNotification",
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    title: {
      type: String,
      default: "Notification"
    },
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "info",
      validator: (value) => ["success", "info", "warning", "danger"].includes(value)
    },
    timeout: {
      type: Number,
      default: 3000 // Default 3 seconds, 0 means no auto-close
    },
    position: {
      type: String,
      default: "top-center",
      validator: (value) => ["top-right", "top-left", "bottom-right", "bottom-left", "top-center", "bottom-center"].includes(value)
    }
  },
  emits: ["close"],
  data() {
    return {
      timeoutId: null
    };
  },
  computed: {
    positionClass() {
      return `toast-${this.position}`;
    }
  },
  mounted() {
    if (this.timeout > 0) {
      this.timeoutId = setTimeout(() => {
        this.close();
      }, this.timeout);
    }
  },
  beforeUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  },
  methods: {
    close() {
      this.$emit("close", this.id);
    },
    getColor(type) {
      const colors = {
        success: "bg-gradient-success",
        info: "bg-gradient-info",
        warning: "bg-gradient-warning",
        danger: "bg-gradient-danger"
      };
      return colors[type] || colors.info;
    },
    getIconName(type) {
      const icons = {
        success: "check_circle",
        info: "info",
        warning: "warning",
        danger: "error"
      };
      return icons[type] || icons.info;
    }
  }
};
</script>

<style scoped>
.toast-notification {
  min-width: 300px;
  max-width: 400px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  z-index: 9999;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
